import { resolveMainRepoFromWorktreeGitFile } from '../../git/worktrees/resolve-main-repo-from-git-file.js';

/** Main repository that owns a linked worktree checkout (or the checkout itself at bridge root). */
export function resolveMainRepoPath(checkoutPath: string): string {
  return resolveMainRepoFromWorktreeGitFile(checkoutPath) || checkoutPath;
}
